import React from 'react';
import { IconVariant } from '@components/ItemWithLogo';
import { AvTooltip } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { ellipsis } from '@fabric-ui/utils';
import { Box, SxProps } from '@mui/material';
import AvItemWithLogoGroup, { IconSize } from '../../../../components/AvItemWithLogoGroup';
import { customTickClassnames } from '../../../../components/Widgets/AvComposedWidget';
import { SourceIconsFormatterClassNames } from './SourceIconsFormatter.utils';

const SourceIconsFormatter = ({
  value,
  isXRotated,
  isYRotated,
  showText = true,
  isVertical,
  hasWidthLimit = true,
  itemMaxWidth,
  rotateText90deg,
  sx,
}: {
  value: string;
  isXRotated?: boolean;
  isYRotated?: boolean;
  showText?: boolean;
  isVertical?: boolean;
  hasWidthLimit?: boolean;
  itemMaxWidth?: number | string;
  rotateText90deg?: boolean;
  sx?: SxProps;
}) => {
  const sourcesArray = value.split(',').map(item => item.trim());
  return (
    <Box
      className={sourcesArray.length > 1 ? SourceIconsFormatterClassNames.multiIcons : SourceIconsFormatterClassNames.singleIcon}
      sx={{
        pointerEvents: 'all',
        color: theme => theme.palette.colors.neutrals[500],
        fontSize: '12px',
        width: '100%',
        ...sx,
        ...(!showText && { mt: 0 }),
      }}>
      <Box
        sx={{
          ...(isVertical ? flex.colCenter : flex.justifyEnd),
          gap: 1,
          width: '100%',
        }}>
        <AvItemWithLogoGroup
          variant={IconVariant.sourcesMapByName}
          items={sourcesArray}
          size={IconSize.collapsed}
          limit={1}
          inputVariantSpace={12}
        />
        {showText && (
          <Box
            {...(hasWidthLimit && { width: itemMaxWidth || '100%' })}
            sx={{
              width: '100%',
              ...(isVertical
                ? rotateText90deg
                  ? { ...flex.justifyEnd, pr: 1 }
                  : isXRotated
                    ? flex.justifyEnd
                    : flex.center
                : flex.justifyStartCenter),
              '.recharts-cartesian-axis-tick &': {
                justifyContent: 'center',
              },
              ...ellipsis,
              [`${customTickClassnames.xAxisVertical} &`]: rotateText90deg
                ? { transform: 'rotate(-90deg) translate(-20%, 0%)', transformOrigin: 'center center' }
                : undefined,
              [`${customTickClassnames.xAxisSlanted} &`]: isXRotated
                ? {
                    transform: 'rotate(-45deg) translate(-50%, -50%)',
                    transformOrigin: 'center center',
                    justifyContent: 'flex-end',
                    width: '85%',
                  }
                : undefined,

              [`${customTickClassnames.yAxisSlanted} &`]: isYRotated
                ? {
                    transform: 'rotate(-45deg) translate(-50%, -50%)',
                    transformOrigin: 'center center',
                  }
                : undefined,

              [`${customTickClassnames.yAxisHorizontal} &`]: isYRotated
                ? {
                    transform: 'rotate(-45deg) translate(-50%, -50%)',
                    transformOrigin: 'center center',
                  }
                : {
                    justifyContent: 'flex-start',
                    width: 110,
                  },
            }}>
            <AvTooltip>{value}</AvTooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SourceIconsFormatter;
